import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    ref: "elSelect",
    modelValue: _ctx.internalStatus,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalStatus) = $event)),
    placeholder: "Статус заказ-наряда",
    persistent: false,
    disabled: _ctx.disabled,
    onChange: _ctx.onDropdownStatusSelected,
    onVisibleChange: _ctx.onDropdownVisibilityChange
  }, _createSlots({
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.dropdownMenuLabel), 1)
    ]),
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.dropdownMenuLabel), 1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropdownStatusesList, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.name,
          value: item.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["label", "value"]))
      }), 128))
    ]),
    _: 2
  }, [
    (_ctx.cancellable && (_ctx.dropdownStatusesList?.length || _ctx.initialStatus != _ctx.status))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_el_link, {
              style: {"font-size":".9rem"},
              type: _ctx.initialStatus == _ctx.status ? 'info' : 'warning',
              disabled: _ctx.initialStatus == _ctx.status,
              underline: false,
              onClick: _ctx.onDropdownCancelChangesClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(" отменить изменения ")
              ]),
              _: 1
            }, 8, ["type", "disabled", "onClick"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "disabled", "onChange", "onVisibleChange"]))
}